import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const pleo = defineConnector({
  identifier: "pleo",
  name: "Pleo",
  tagLine: "Business spending management",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://[^/]*\\.pleo\\.io/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Enter your Pleo instance details",
      items: [
        {
          kind: "markdown",
          content: "Enter the details for your Pleo instance.",
        },
        {
          kind: "input",
          label: "OAuth Subdomain",
          placeholder: "auth",
          required: true,
          target: { kind: "configuration", field: "subdomain" },
          helperText:
            "The auth subdomain of your Pleo environment. (e.g. https://auth.pleo.io)",
        },
        {
          kind: "input",
          label: "API Subdomain",
          placeholder: "external",
          required: true,
          target: { kind: "configuration", field: "apiSubdomain" },
          helperText:
            "The API subdomain of your Pleo environment. (e.g. https://external.pleo.io)",
        },
      ],
    },
    {
      title: "Create a Pleo app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [Pleo Developer Portal](https://developer.pleo.io/) and create a new OAuth application to get your client ID and client secret.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/pleo/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Pleo account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Pleo account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: (configuration) =>
      `https://${configuration.subdomain}.pleo.io/oauth/authorize`,
    tokenEndpoint: (configuration) =>
      `https://${configuration.subdomain}.pleo.io/oauth/token`,
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: (configuration) =>
      `https://${configuration.apiSubdomain}.pleo.io/v3/companies`,
  },
  publicEnvVars: ({ apiSubdomain, subdomain }) => ({
    PLEO_API_URL: apiSubdomain ? `https://${apiSubdomain}.pleo.io` : "",
    PLEO_URL: subdomain ? `https://${subdomain}.pleo.io` : "",
  }),
});
